// extracted by mini-css-extract-plugin
module.exports = {"logo":"Login_logo__3wuD-","widget":"Login_widget__2Eg-N","SignUp":"Login_SignUp__iAHOu"};